import Modal from "@/components/common/modal";
import { DialogFooter } from "@/components/ui/dialog";
import { Button } from "@elaniintc/goes-design-system";
import { formatCommentText } from "@/utils/procedures-ui";

export interface CommentWithGroup {
  text: string;
  groupName: string;
}

interface Props {
  isOpen: boolean;
  reason?: string;
  reasons?: CommentWithGroup[];
  onClose: () => void;
  onAccept: () => void;
}

const DenyReasonShowModal = ({
  isOpen,
  reason,
  reasons,
  onClose,
  onAccept,
}: Props) => {
  const commentsToShow =
    reasons || (reason ? [{ text: reason, groupName: "Comentario" }] : []);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Comentario de observación"
      description="Motivo original de la observación de este campo."
      modalContentClassName="max-w-[520px] w-full gap-7 border border-neutral"
    >
      <div className="flex flex-col gap-6 ">
        <div className="max-h-[400px] overflow-y-auto pr-2">
          <div className="flex flex-col gap-3">
            {commentsToShow.map((comment, i) => (
              <div
                key={`${comment.groupName}-${comment.text}-${i + 1}`}
                className="bg-surface-warning-accent-quiet border-warning-quiet border rounded-lg p-2"
              >
                <p className="text-body-loud font-semibold text-sm leading-2xl">
                  Comentario del analista ({comment.groupName}):
                </p>
                <p className="font-body text-body text-size-body whitespace-pre-line text-justify break-words min-w-0">
                  {formatCommentText(comment.text)}
                </p>
              </div>
            ))}
          </div>
        </div>
        <DialogFooter className="pt-1">
          <div className="w-full ">
            <Button
              size="lg"
              type="button"
              className="w-full rounded-lg"
              variant="tertiary"
              onClick={onAccept}
            >
              Aceptar
            </Button>
          </div>
        </DialogFooter>
      </div>
    </Modal>
  );
};

export default DenyReasonShowModal;
